import { render, staticRenderFns } from "./CbsUpload.vue?vue&type=template&id=6bbe0c0e&scoped=true&"
import script from "./CbsUpload.vue?vue&type=script&lang=js&"
export * from "./CbsUpload.vue?vue&type=script&lang=js&"
import style0 from "./CbsUpload.vue?vue&type=style&index=0&id=6bbe0c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbe0c0e",
  null
  
)

export default component.exports